import { useState, useCallback } from "react";
import {
  Box,
  Switch,
  FormControlLabel,
  ToggleButtonGroup,
  ToggleButton,
  Typography,
} from "@mui/material";
import {
  IconChartBar,
  IconChartTreemap,
  IconChartPie,
} from "@tabler/icons-react";

import MethodsTreemap from "./Treemap";
import StackedPieChart from "./ChartPie";
import MethodBarChart from "./ChartBar";
import ChartCard from "./ChartCard";

const MethodBreakdown = ({ uid }) => {
  const [chartType, setChartType] = useState("pie");
  const [showBreakdown, setShowBreakdown] = useState(false);

  const dataLoader = (user) => {
    return user.snapshot.methodsBreakdown(user);
  };

  const isEmptyChecker = (data) => {
    return !data || !data.methods || data.methods.length === 0;
  };

  const handleChartTypeChange = useCallback((_, newType) => {
    if (newType !== null) setChartType(newType);
  }, []);

  return (
    <ChartCard
      uid={uid}
      title="Top Methods"
      dataLoader={dataLoader}
      isEmptyChecker={isEmptyChecker}
      height={400}
      headerAction={
        <ToggleButtonGroup
          value={chartType}
          exclusive
          onChange={handleChartTypeChange}
          size="large"
          sx={{ mr: 1 }}
        >
          <ToggleButton value="treemap" sx={{ px: 1, py: 0.5 }}>
            <IconChartTreemap />
          </ToggleButton>
          <ToggleButton value="pie" sx={{ px: 1, py: 0.5 }}>
            <IconChartPie />
          </ToggleButton>
          <ToggleButton value="bar" sx={{ px: 1, py: 0.5 }}>
            <IconChartBar />
          </ToggleButton>
        </ToggleButtonGroup>
      }
    >
      {(data) => (
        <>
          <Box sx={{ height: 350 }}>
            {chartType === "treemap" && (
              <MethodsTreemap
                categories={data.categories}
                methods={data.methods}
                grouped={!showBreakdown}
              />
            )}
            {chartType === "pie" && (
              <StackedPieChart
                categories={data.categories}
                methods={data.methods}
                showBreakdown={showBreakdown}
              />
            )}
            {chartType === "bar" && (
              <MethodBarChart
                categories={data.categories}
                methods={data.methods}
                showBreakdown={showBreakdown}
              />
            )}
          </Box>
          <Box
            sx={{
              px: 1,
              pt: 1,
              borderTop: "1px solid #eee",
              textAlign: "right",
            }}
          >
            <FormControlLabel
              control={
                <Switch
                  checked={showBreakdown}
                  onChange={(e) => setShowBreakdown(e.target.checked)}
                  size="small"
                />
              }
              label={
                <Typography variant="caption" color="text.secondary">
                  Show breakdown
                </Typography>
              }
              style={{
                flexFlow: "row-reverse",
              }}
            />
          </Box>
        </>
      )}
    </ChartCard>
  );
};

export default MethodBreakdown;
